import { render, staticRenderFns } from "./MCPBase.vue?vue&type=template&id=2f639683&scoped=true&"
import script from "./MCPBase.vue?vue&type=script&lang=js&"
export * from "./MCPBase.vue?vue&type=script&lang=js&"
import style0 from "./MCPBase.vue?vue&type=style&index=0&id=2f639683&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f639683",
  null
  
)

export default component.exports